<template>
    <div style="padding: 20px;">
        <PostForm
            :status="status"
            :section="section"
            :category="category"
            :categories="categories"
            :is-admin="isAdmin"
            @post-added="handlePostAdded"
            @cancel="handleCancel"
            @reset="resetForm"
        />
    </div>
</template>

<script>
import PostForm from '../components/PostForm.vue';
import { mapState } from "vuex";

export default {
    components: {
        PostForm
    },
    data() {
        return {
            status: null,
            section: null,
            category: null,
            categories: [],
            post: null,
            loading: true
        };
    },
    created() {
        this.getQueryParams();
        this.fetchCategories();
    },
    computed: {
        ...mapState(['isAdmin', 'defaultStatusId']),
    },
    methods: {
        getQueryParams() {
            const params = new URLSearchParams(window.location.search);
            this.status = Number(params.get('status')) || this.defaultStatusId;
            this.section = Number(params.get('section')) || null;
            this.category = Number(params.get('category')) || null;
        },
        fetchCategories() {
            this.$http.get('/http_api/categories')
                .then(({data}) => {
                    this.categories = data.data;
                })
                .catch(error => {
                    console.error('Error fetching categories:', error);
                    this.popNotification('Something went wrong on our side. Could not load categories. Please try again or contact ruben@productlift.dev', 'danger');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handlePostAdded(post) {
            this.post = post;
        },
        handleCancel() {
            window.location.href = '/';
        },
        resetForm() {
            // Optionally reset any page state here
        },
        popNotification(message, type) {
            // Implement this method or import it from a mixin
            console.log(`${type} notification: ${message}`);
        }
    }
};
</script>